import React, { useEffect, useRef, useCallback } from "react";
import ReactDOM from "react-dom";
import { CSSTransition } from "react-transition-group";
import "./MdlSidebarOverlay.css";

// ⭐ Props direkt destrukturiert für fehlerfreie und gezielte Dependency-Arrays
const MdlSidebarOverlay = ({ show, open, onClose, title, children }) => {
  const ref = useRef(null);

  // ⭐ closeOnEscapeKeyDown in useCallback verpackt, um eine stabile Referenz zu haben
  const closeOnEscapeKeyDown = useCallback((e) => {
    if ((e.charCode || e.keyCode) === 27) {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    document.body.addEventListener("keydown", closeOnEscapeKeyDown);
    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
    };
  }, [closeOnEscapeKeyDown]); // ⭐ Fehler 1 behoben: Die stabile Funktion als Abhängigkeit eingetragen

  // ⭐ Event-Handler für Klicks außerhalb ebenfalls per useCallback stabilisiert
  const checkIfClickedOutside = useCallback((e) => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (show && ref.current && !ref.current.contains(e.target)) {
      onClose();
    }
  }, [show, onClose]);

  useEffect(() => {
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [checkIfClickedOutside]); // ⭐ Fehler 2 behoben: Nutzt nun die exakte, stabile Handler-Referenz statt 'props'

  const isVisible = show !== undefined ? show : open;

  return ReactDOM.createPortal(
    <CSSTransition
      in={isVisible}
      unmountOnExit
      timeout={{ enter: 0, exit: 300 }}
	  nodeRef={ref}
    >
      {/* ⭐ FIX 1: Der abgedunkelte Hintergrund wird auf zIndex 99999 gezwungen */}
      <div 
        className="modal" 
        onClick={onClose}
		ref={ref}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Dunkelt den Hintergrund sauber ab
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 99999 // 💡 Schiebt das gesamte Portal vor JEDES Element der App
        }}
      >
        {/* ⭐ FIX 2: Die weiße Box wird absolut blickdicht (white) gemacht und auf zIndex 100000 gehoben */}
        <div
          className="modal-content"
          onClick={(e) => e.stopPropagation()}
          
          style={{
            backgroundColor: "#ffffff", // 💡 Garantiert, dass KEIN grauer Text mehr durchschimmert!
            borderRadius: "12px",
            padding: "25px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
            width: "100%",
            maxWidth: "480px",
            maxHeight: "85vh",
            overflowY: "auto",
			overflow: "initial",
            zIndex: 100000
          }}
        >
          <div className="modal-header" style={{ marginBottom: "15px", textAlign: "left" }}>
            <h4 className="modal-title" style={{ margin: 0, fontWeight: "bold", fontSize: "1.2rem", color: "#1d1b31" }}>
              {title}
            </h4>
          </div>
          <div className="modal-body">
            {children}
          </div>
        </div>
      </div>
    </CSSTransition>,
    document.getElementById("root")
  );




};

export default MdlSidebarOverlay;
